import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { DataGrid } from '@mui/x-data-grid';

import { formatTimestampToDate } from '@src/utils/dateHelpers';

import ExpirationDateField from '@src/custom/expiration-date-field';

const columns = [
    {
        field: 'thumbnail',
        headerName: 'Preview',
        width: 100,
        sortable: false,
        renderCell(params) {
            if (!params?.value) return null;

            return (
                <img src={params.value.source} alt={params.value.alt} style={{ maxHeight: '3rem', maxWidth: '100px', margin: 0 }} />
            );
        },
    },
    {
        field: 'display_name',
        type: 'string',
        headerName: 'Title',
        flex: 1,
        sortable: false,
    },
    {
        field: 'created_at',
        type: 'date',
        headerName: 'Uploaded On',
        width: 200,
        sortable: false,
        valueGetter: (params) => params?.value ? new Date(params.value) : null,
        valueFormatter: (params) => params?.value ? formatTimestampToDate(params.value) : '',
    },
    {
        field: 'expired_at',
        type: 'date',
        headerName: 'Expiration Date',
        width: 200,
        sortable: false,
        valueGetter: (params) => params?.value ? new Date(params.value) : null,
        renderCell: (params) => <ExpirationDateField value={params?.value} />,
    },
];

const AttachmentSelectorModal = (props) => {
    const {
        attachmentsData,
        loading,
        onAttachmentSelected,
        onPageChange,
    } = props;

    const handlePaginationModelChange = useCallback((newModel) => {
        onPageChange(newModel.page + 1);
    }, [onPageChange]);

    const handleRowClick = useCallback(({ row }) => {
        onAttachmentSelected(row);
    }, [onAttachmentSelected]);

    return (
        <DataGrid
            autoHeight
            disableColumnMenu
            columns={columns}
            loading={loading}
            paginationModel={{
                page: attachmentsData.page - 1,
                pageSize: attachmentsData.perPage,
            }}
            paginationMode="server"
            rowCount={attachmentsData.total || 0}
            rows={attachmentsData.attachments}
            onPaginationModelChange={handlePaginationModelChange}
            onRowClick={handleRowClick}
        />
    );
};

AttachmentSelectorModal.propTypes = {
    attachmentsData: PropTypes.shape({
        attachments: PropTypes.array.isRequired,
        page: PropTypes.number,
        pageSize: PropTypes.number,
        perPage: PropTypes.number,
        total: PropTypes.number,
    }).isRequired,
    loading: PropTypes.bool,
    onPageChange: PropTypes.func.isRequired,
    onAttachmentSelected: PropTypes.func.isRequired,
};

export default React.memo(AttachmentSelectorModal);
